<template>
  <div>
    <LeftListMember :pos="3"></LeftListMember>
    <div class="g-row2">
      <div class="m-hone1">
        <ul class="g-tablist1">
          <li class="li on">
            <router-link to="/center-equity" class="txt">会员权益</router-link>
          </li>
          <li class="li">
            <router-link to="/center-recharge" class="txt">在线充值</router-link>
          </li>
          <li class="li">
            <router-link to="/center-record" class="txt">充值记录</router-link>
          </li>
        </ul>
        <div class="contect">
          <div class="m-infobox5">
            <div class="box1">
              <img src="@/assets/images/icon1.png" class="icon" alt="" />
              <div class="tit" @click="protocol.show=true" style="cursor: pointer;">《会员VIP服务协议》</div>
            </div>
            <router-link to="/center-recharge" class="link">开通/续费会员VIP</router-link>
            <div class="box2">
              <div class="left" v-if="isVip">
                <img src="@/assets/images/icon2.png" class="icon" alt="" />
                <div class="tit">
                  会员VIP有效期：<span>{{ userInfo.vipTime.split(' ')[0] }}</span>
                </div>
                <div class="tit" style="margin-left: 100px;">
                  数据下载剩余：
                  <div v-if="userInfo.isDownloadUnlimit" style="display: inline-block;"><span>无限制</span></div>
                  <div v-else style="display: inline-block;"><span>{{ userInfo.downloadNumLeft }}</span>条</div>
                </div>
              </div>
              <div class="right" v-else>您还未开通会员VIP权限</div>
            </div>
            <div class="box3">
              <div class="top">
                <div class="tit">会员权益</div>
              </div>
              <div class="txt" v-html="$store.state.config.bk_vip_description">
<!--                <div class="p">1，可根据书名，ISBN，供应商等信息查询；</div>-->
<!--                <div class="p">2，可根据，出版时间，定价，折扣，进行升序或降序‘</div>-->
<!--                <div class="p">3，可根据选中相应数据，加入到定订库；</div>-->
<!--                <div class="p">4，可通过ISBN批量查询，单个ISBN结果大于5条，只显示折扣底；前5条（数值可改）</div>-->
<!--                <div class="p">5，支持勾选只看最底价折扣，此时只看显示最底折扣，当多个折扣相同时根据数据上传时间优先显示。</div>-->
<!--                <div class="p">6，支持根据供应商名称查询，可显示该供应商下全部数据。支持勾选加入订单库；</div>-->
<!--                <div class="p">7，订单库；自定义增减删查订单，可设定当前订单；对定订单内单条数据订数进行修改，可统一个更改订数</div>-->
<!--                <div class="p">8，将定单提交完成，系统自动将定单内图书目录分配至供应商订单库；</div>-->
<!--                <div class="p">9，支持勾选，入订单库；</div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <protocol-dialog :show.sync="protocol.show" :type="protocol.type"></protocol-dialog>
  </div>
</template>

<script>
import LeftListMember from "@/components/LeftListMember.vue";
import ProtocolDialog from "@/components/ProtocolDialog.vue";
import dayjs from 'dayjs'
export default {
  components: {
    ProtocolDialog,
    LeftListMember,
  },
  data() {
    return {
      protocol: {
        type: 'bk_member_vip',
        show: false
      }
    }
  },
  computed: {
    userInfo(){
      return this.$store.state.user.userInfo
  },
    isVip(){
      return dayjs(this.$store.state.user.userInfo.vipTime).unix() > dayjs().unix()
    }
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
